import { Button, Col, Dropdown, Row, Text } from "rsuite";
import { AirplaneFill, App, ArrowDown, ArrowRightSquare, BuildingFill, Calendar, Calendar2, CalendarFill, CardHeading, CardText, CarFront, Cash, ChatDotsFill, CreditCard, Envelope, GeoAltFill, PeopleFill, PersonCircle, RecordCircleFill, SuitcaseFill, TelephoneFill, CheckCircleFill, Pen, CarFrontFill } from "react-bootstrap-icons";
import { SPECIAL_REQUESTS } from "../my-type";
import type { OrderDisplayProps, Vehicle } from "../my-type";
import { OrderActionType, OrderStatus, OrderType, UserRole } from "../my-enum";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authUserData } from "../service";
import { getSupplierById } from "../service/SupplierService";
//import styles from "../pages/style.module.css"


export default function OrderDisplay({ order, isShowDetail, userRole, onOrderAction }: OrderDisplayProps) {

  const [isShowOrderDetail, setIsShowOrderDetail] = useState<boolean>(isShowDetail);
  const [vehicleTypes, setVehicleTypes] = useState<Vehicle[] | undefined>(undefined);
  const [supplierName, setSupplierName] = useState<string | null>(null);
  const navigate = useNavigate();
  const user = authUserData();

  useEffect(() => {
    if (!vehicleTypes) {
      if (user!.team && user!.team.vehicleData) {
        let vechileList = JSON.parse(user!.team.vehicleData);
        setVehicleTypes(vechileList);
      }
    }
  }, [user, vehicleTypes])

  // Re-sync state when order or isShowDetail prop changes
  useEffect(() => {
    setIsShowOrderDetail(isShowDetail);
  }, [order, isShowDetail])

  // Fetch supplier name when supplierId exists
  useEffect(() => {
    const fetchSupplierName = async () => {
      if (order?.supplierId) {
        try {
          const supplier = await getSupplierById(order.supplierId);
          if (supplier) {
            setSupplierName(supplier.name);
          }
        } catch (error) {
          console.error('Error fetching supplier:', error);
        }
      } else {
        setSupplierName(null);
      }
    };
    fetchSupplierName();
  }, [order?.supplierId])

  // Validate order data to prevent Invalid URL errors
  if (!order || !order.orderID) {
    console.error('Invalid order data:', order);
    return <div style={{ padding: '15px', color: 'red' }}>訂單資料錯誤</div>;
  }

  function getOrderTypeKey(orderType: OrderType) {
    let keyStr: string = '';
    switch (orderType) {
      case 'in':
        keyStr = '接機';
        break
      case 'out':
        keyStr = '送機';
        break;
      case 'point_to_point':
        keyStr = '接送';
        break;
      default:
        keyStr = 'N/A';
    }

    return keyStr;
  }

  function getDisplayDateTimeString(dateTime: Date) {
    let parsedTime = new Date(dateTime);
    let strDate = parsedTime.toLocaleString('zh-TW', { year: 'numeric', month: '2-digit', day: '2-digit' });
    let strTime = parsedTime.toLocaleTimeString('zh-TW', { hourCycle: 'h23', hour: "2-digit", minute: "2-digit" });
    //console.log(strDate + ' ' + strTime);
    return strDate + ' ' + strTime;
  }

  const statusStyle = () => {

    let styleColor = {};
    switch (order.status) {
      case OrderStatus.派車中:
        styleColor = { color: 'green', fontWeight: 'bold' };
        break;
      case OrderStatus.已派車:
        styleColor = { color: 'orange', fontWeight: 'bold' };
        break;
      case OrderStatus.載客中:
        styleColor = { color: 'blue', fontWeight: 'bold' };
        break;
      default:
        styleColor = { color: 'GrayText' };
    }

    return styleColor;

  }

  const renderDriverActionButton = (isBlock: boolean) => {
    if (userRole === UserRole.Driver && order.driverUID === user?.id) {
      if (order.status === OrderStatus.已派車) {
        return <Button appearance="primary" block={isBlock} onClick={() => {
          onOrderAction(order, OrderActionType.Next);
        }}>
          出發載客
        </Button>
      }


      if (order.status === OrderStatus.已出發) {
        return <Button appearance="primary" block={isBlock} onClick={() => {
          onOrderAction(order, OrderActionType.Next);
          //setIsShowOrderDetail(false);
        }}>
          乘客上車
        </Button>


      }


      if (order.status === OrderStatus.載客中) {
        return <Button appearance="primary" block={isBlock} onClick={() => {
          onOrderAction(order, OrderActionType.Next);
          //setIsShowOrderDetail(false);
        }}>
          完成訂單
        </Button>

      }

    } else if (userRole === UserRole.Driver && order.driverUID === 0) {
      if (order.status === OrderStatus.派車中) {
        return <Button appearance="primary" block={isBlock} onClick={() => {
          onOrderAction(order, OrderActionType.Next);
        }}>
          我要接單
        </Button>
      }
    } else {
      return <></>
    }
  }

  const renderDropdownItems = () => {

    let dropdownItems = [];

    // 乘客
    if (userRole === UserRole.Rider && !window.location.pathname.endsWith(`/rider/order/${order.orderID}/transfer`)) {
      if (order.status === OrderStatus.派車中 || order.status === OrderStatus.已派車) {
        dropdownItems.push(<Dropdown.Item key="cancel" onClick={() => {
          onOrderAction(order, OrderActionType.Cancel);
          setIsShowOrderDetail(false);
        }}>
          取消預約
        </Dropdown.Item>);
      }

      if (order.status === OrderStatus.派車中 && !order.paymentPaid && !order.isAdminOrder) {
        dropdownItems.push(<Dropdown.Item key="payment" onClick={() => {
          if (order.orderID && typeof order.orderID === 'string') {
            navigate(`/rider/order/${order.orderID}/payment/ecpay/credit-card`);
          }
        }}>
          進行付款
        </Dropdown.Item>);
      }

    }


    return dropdownItems;
  }

  const orderDisplay = () => {
    //console.log(order);
    let flightTime: Date | undefined = undefined;
    if (order.flightTime !== null) {
      flightTime = new Date(order.flightTime);
    }
    //console.log(newDate.toLocaleTimeString('zh-TW', { hourCycle: 'h24' }));
    return (
      <div style={{ fontSize: '16px' }}>
        {isShowDetail && <div style={{ paddingBottom: '15px' }}>
          <Row>
            <Col xs={2}>{renderDriverActionButton(false)}</Col>
            <Col xs={22} style={{ textAlign: 'right' }}>
              {renderDropdownItems().length > 0 &&
                <Dropdown title="更多" placement="bottomEnd" icon={<App />}>
                  {renderDropdownItems()}
                </Dropdown>
              }
            </Col>
          </Row>
        </div>
        }

        <div style={{ backgroundColor: isShowDetail ? '#dce0dd' : '#dce0dd', borderTopLeftRadius: '5px', borderTopRightRadius: '5px', height: '30px' }}>
          <Row style={{ paddingTop: '5px', paddingLeft: '15px' }}>
            <Col>
              {(order.orderType === OrderType.接機 || order.orderType === OrderType.送機) && <AirplaneFill />}
              {order.orderType === OrderType.接送 && <CarFrontFill />}
            </Col>
            <Col style={{ textAlign: 'left' }}><Text weight="extrabold">{getOrderTypeKey(order.orderType)}訂單&nbsp;{order.orderID}</Text></Col>
            {/* <Col style={{ textAlign: 'right' }}>{!isShowDetail && <CaretDownFill />}</Col> */}
          </Row>
        </div >

        <div style={{ paddingLeft: '15px', paddingRight: '15px', paddingTop: '25px', paddingBottom: '20px', backgroundColor: '#f5f7fa' }}>

          {(order.orderType === OrderType.送機 || order.orderType === OrderType.接送) &&
            <><Row>
              <Col><Calendar /></Col>
              <Col xs={22} style={{ textAlign: 'left' }}><Text weight="bold">搭乘時間</Text><span style={{ color: 'GrayText' }}>{getDisplayDateTimeString(order.rideTime)}</span></Col>
            </Row>
              <br></br>
            </>
          }

          {order.orderType === OrderType.接機 && !isShowDetail && <>
            <Row>
              <Col><CalendarFill /></Col>
              <Col xs={22} style={{ textAlign: 'left' }}><Text weight="bold">航班時間</Text>
                <span style={{ color: 'GrayText' }}>
                  {order.flightNo} {flightTime ? flightTime.toLocaleDateString('zh-TW', { year: 'numeric', month: '2-digit', day: '2-digit' }) : ''} {flightTime ? flightTime.toLocaleTimeString('zh-TW', { hourCycle: 'h23', hour: "2-digit", minute: "2-digit" }) : ''}
                </span>
              </Col>
            </Row>
            <Row>
              <Col><GeoAltFill /></Col>
              <Col xs={22} style={{ textAlign: 'left' }}><Text weight="bold">下車地址</Text>
                <span style={{ color: 'GrayText' }}>
                  {order.address}
                </span>
              </Col>
            </Row>
          </>
          }

          {order.orderType === OrderType.接送 && !isShowDetail && <>
            <Row>
              <Col><GeoAltFill /></Col>
              <Col xs={22} style={{ textAlign: 'left' }}><Text weight="bold">下車地址</Text>
                <span style={{ color: 'GrayText' }}>
                  {order.destinationAddress}
                </span>
              </Col>
            </Row>
          </>
          }

          <Row>
            <Col><GeoAltFill /></Col>
            <Col xs={22} style={{ textAlign: 'left' }}><Text weight="bold">上車地址</Text>
              <span style={{ color: 'GrayText' }}>
                {order.orderType === OrderType.接機 ? order.terminal : order.address}
              </span>
              {(order.orderType === OrderType.送機 || order.orderType === OrderType.接送) && isShowDetail && <>
                <br></br>
                <Button
                  size="xs"
                  appearance="primary"
                  onClick={() => {
                    const address = order.orderType === OrderType.接機 ? order.terminal : order.address;
                    if (address && typeof address === 'string' && address.trim()) {
                      try {
                        window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
                      } catch (error) {
                        console.error('Failed to open navigation:', error);
                        alert('無法開啟導航，地址格式錯誤');
                      }
                    } else {
                      alert('無法開啟導航，地址不存在');
                    }
                  }}
                >
                  <GeoAltFill style={{ marginRight: '4px' }} />
                  導航
                </Button>
              </>}
            </Col>
          </Row>

          {!isShowDetail && <>
            <br />
            <Row>
              <Col>
                <Button appearance="ghost" onClick={(e) => {
                  e.stopPropagation(); // Prevent the click from propagating to the parent div
                  if (order.orderID && typeof order.orderID === 'string') {
                    navigate(`../order/${order.orderID}`);
                  }
                }}>查看詳情</Button>
              </Col>
              <Col xs={12} md={5}>{renderDriverActionButton(true)}</Col>
            </Row>
          </>}

          {isShowOrderDetail && <>
            <br></br>

            <Row>
              <Col><RecordCircleFill /></Col>
              <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">訂單狀態</Text>
                <span style={statusStyle()}>{OrderStatus[order.status]}</span>
              </Col>
              <Col><CreditCard /></Col>
              <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">付款狀態</Text>
                <span style={statusStyle()}>{order.paymentPaid ? order.isAdminOrder ? '管理單' : '已付款' : '未付款'}</span>
              </Col>
            </Row>

            <br></br>



            {order.flightNo && order.flightNo.length > 0 &&
              <>
                <Row>
                  <Col><Calendar /></Col>
                  <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">{getOrderTypeKey(order.orderType)}日期</Text><span style={{ color: 'GrayText' }}>{flightTime!.toLocaleString('zh-TW', { year: 'numeric', month: '2-digit', day: '2-digit' })}</span></Col>
                  <Col><CalendarFill /></Col>

                  <Col style={{ textAlign: 'left' }}><Text weight="bold">航班時間</Text><span style={{ color: 'GrayText' }}>
                    {order.flightNo} {flightTime!.toLocaleTimeString('zh-TW', { hourCycle: 'h23', hour: "2-digit", minute: "2-digit" })}</span></Col>
                </Row>
                <br></br>
              </>
            }
            <Row>
              <Col><BuildingFill /></Col>
              <Col xs={22} style={{ textAlign: 'left' }}><Text weight="bold">下車地址</Text>
                <span style={{ color: 'GrayText' }}>
                  {order.orderType === OrderType.送機 ? order.terminal : order.orderType === OrderType.接送 ? order.destinationAddress : order.address}
                </span>

                {(order.orderType === OrderType.接機 || order.orderType === OrderType.接送) && <>
                  <br></br>
                  <Button
                    size="xs"
                    appearance="primary"
                    onClick={() => {
                      const address = order.orderType === OrderType.接機 ? order.address : order.destinationAddress;
                      if (address && typeof address === 'string' && address.trim()) {
                        try {
                          window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
                        } catch (error) {
                          console.error('Failed to open navigation:', error);
                          alert('無法開啟導航，地址格式錯誤');
                        }
                      } else {
                        alert('無法開啟導航，地址不存在');
                      }
                    }}
                  >
                    <GeoAltFill style={{ marginRight: '4px' }} />
                    導航
                  </Button>
                </>
                }
              </Col>

            </Row>
            <br></br>
            {order.viaPoints && order.viaPoints.length > 0 && <>
              <Row>
                <Col><ArrowDown /></Col>
                <Col style={{ textAlign: 'left' }}>
                  <Text weight="bold">途經點</Text>
                  {order.viaPoints.map((point, index) => (
                    <div key={index} style={{ color: 'GrayText', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '4px' }}>
                      <span>{index + 1}. {point}</span>
                      <Button
                        size="xs"
                        appearance="primary"
                        onClick={() => {
                          if (point && typeof point === 'string' && point.trim()) {
                            try {
                              window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(point)}`, '_blank');
                            } catch (error) {
                              console.error('Failed to open navigation:', error);
                              alert('無法開啟導航，地址格式錯誤');
                            }
                          } else {
                            alert('無法開啟導航，地址不存在');
                          }
                        }}
                        style={{ marginTop: '8px' }}
                      >
                        <GeoAltFill style={{ marginRight: '4px' }} />
                        導航
                      </Button>
                    </div>
                  ))}
                </Col>
              </Row>
              <br></br>
            </>}
            {/* <Row>
              <Col><Calendar /></Col>
              <Col xs={22} style={{ textAlign: 'left' }}><Text weight="bold">預估抵達</Text>
                <span style={{ color: 'GrayText' }}>{getDisplayDateTimeString(order.estArriveTime)}&nbsp;{order.orderType === OrderType.接機 && '(通關時間預估30分鐘)'}&nbsp;(不含塞車時間)</span>
              </Col>
            </Row> */}
            <br></br>
            {/* <Row>
              <Col><CardHeading /></Col>
              <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">搭乘需求</Text>
              </Col>
            </Row>
            <br></br> */}
            <Row>
              <Col><CarFront /></Col>
              <Col xs={8} style={{ textAlign: 'left' }}>
                <Text weight="bold">車種</Text>
                <span style={{ color: 'GrayText' }}>{vehicleTypes && vehicleTypes.find((element) => element.vehicleID === order.vehicleID)?.vehiclename}</span>
                {order.assignedCarModel && order.assignedCarModel.trim() !== "" && (
                  <>
                    <br></br>
                    <Text weight="bold">指定車型</Text>
                    <span style={{ color: 'GrayText' }}>{order.assignedCarModel}</span>
                  </>
                )}
              </Col>
              <Col><Cash /></Col>
              <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">車資</Text><span style={{ color: 'GrayText' }}>{order.rideFee} 元</span>
                {((order.driverCommission) && (userRole === UserRole.Lead || userRole === UserRole.Driver || userRole === UserRole.Admin)) &&
                  <><br></br><Text weight="bold">司機收款</Text><span style={{ color: 'GrayText' }}>{order.driverCommission}</span></>
                }
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col><SuitcaseFill /></Col>
              <Col xs={22} style={{ textAlign: 'left' }}><Text weight="bold">行李數量</Text><span style={{ color: 'GrayText' }}>{order.luggages ? order.luggages : 'N/A'}</span></Col>
            </Row>
            <br></br>
            <Row>
              <Col><PersonCircle /></Col>
              <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">乘客姓名</Text><span style={{ color: 'GrayText' }}>{order.passengerName}</span></Col>
              <Col><TelephoneFill /></Col>
              <Col style={{ textAlign: 'left' }}><Text weight="bold">乘客電話</Text><span style={{ color: 'GrayText' }}>{order.passengerPhone}</span></Col>
            </Row>
            <br></br>
            {/* <Row>
              <Col xs={2}></Col>
              <Col style={{ textAlign: 'left' }}><Text weight="bold">身分證字號/外籍旅客護照</Text><span style={{ color: 'GrayText' }}>{order.passengerID}</span></Col>
            </Row>
            <br></br> */}
            <Row>
              <Col><PeopleFill /></Col>
              <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">乘客人數</Text><span style={{ color: 'GrayText' }}>{order.passengerAdult}乘客．{order.passengerBaby}兒童</span></Col>
            </Row>
            <br></br>
            <Row>
              <Col><Envelope /></Col>
              <Col style={{ textAlign: 'left' }}>
                <Text weight="bold">乘客Email</Text>
                <span style={{ color: 'GrayText' }}>{order.email ? order.email : 'N/A'}</span>
                {order.email && <>
                  <br></br>
                  <Button
                    size="xs"
                    appearance="primary"
                    onClick={() => {
                      navigator.clipboard.writeText(order.email!);
                      alert('Email已複製到剪貼簿');
                    }}
                  >
                    <Envelope style={{ marginRight: '4px' }} />
                    複製Email
                  </Button>
                </>}
              </Col>
            </Row>
            <br></br>
            {(order.chatApp || (order as any).chatID) && <>
              <Row>
                <Col><ChatDotsFill /></Col>
                <Col style={{ textAlign: 'left' }}>
                  <Text weight="bold">旅客聊天資訊</Text>
                  {order.chatApp && <>
                    <br />
                    <span style={{ color: 'GrayText' }}>聊天軟體: {order.chatApp}</span>
                  </>}
                  {(order as any).chatID && <>
                    <br />
                    <span style={{ color: 'GrayText' }}>聊天 ID: {(order as any).chatID}</span>
                  </>}
                </Col>
              </Row>
              <br></br>
            </>}
            <Row>
              <Col><CardHeading /></Col>
              <Col style={{ textAlign: 'left' }}><Text weight="bold">乘車備註</Text><span style={{ color: 'GrayText' }}>{order.luggageNote ? order.luggageNote : 'N/A'}</span></Col>
            </Row>
            <br></br>
            {order.meetAndGreetDetails && order.meetAndGreetDetails.trim() !== '' && <>
              <Row>
                <Col><CheckCircleFill /></Col>
                <Col style={{ textAlign: 'left' }}>
                  <Text weight="bold">接機舉牌資訊</Text>
                  <span style={{ color: 'GrayText' }}>{order.meetAndGreetDetails}</span>
                </Col>
              </Row>
              <br></br>
            </>}
            {order.specialRequests && order.specialRequests.length > 0 && <>
              <Row>
                <Col><CheckCircleFill /></Col>
                <Col style={{ textAlign: 'left' }}>
                  <Text weight="bold">特殊需求</Text>
                  <div style={{ color: 'GrayText' }}>
                    {order.specialRequests.map((requestValue, index) => {
                      const request = SPECIAL_REQUESTS.find(r => r.value === requestValue);
                      return request ? (
                        <div key={index}>• {request.label}</div>
                      ) : null;
                    })}
                  </div>
                </Col>
              </Row>
              <br></br>
            </>}
            {(order.sourceChannel || order.externalBookingNo || order.supplierId) && <>
              <Row>
                <Col><CardHeading /></Col>
                <Col style={{ textAlign: 'left' }}>
                  <Text weight="bold">外部訂單資訊</Text>
                </Col>
              </Row>
              {order.sourceChannel && <>
                <Row>
                  <Col></Col>
                  <Col xs={8} style={{ textAlign: 'left' }}>
                    <Text weight="bold">訂單來源</Text>
                    <span style={{ color: 'GrayText' }}>{order.sourceChannel}</span>
                  </Col>
                </Row>
              </>}
              {order.externalBookingNo && <>
                <Row>
                  <Col></Col>
                  <Col style={{ textAlign: 'left' }}>
                    <Text weight="bold">外部訂單編號</Text>
                    <span style={{ color: 'GrayText' }}>{order.externalBookingNo}</span>
                  </Col>
                </Row>
              </>}
              {order.supplierId && <>
                <Row>
                  <Col></Col>
                  <Col style={{ textAlign: 'left' }}>
                    <Text weight="bold">供應商</Text>
                    <span style={{ color: 'GrayText' }}>{supplierName || `ID: ${order.supplierId}`}</span>
                  </Col>
                </Row>
              </>}
              <br></br>
            </>}



            {order.driver && <>
              <Row>
                <Col><CarFront /></Col>
                <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">司機姓名</Text><span style={{ color: 'GrayText' }}>{order.driver.driverName}</span></Col>
                <Col><TelephoneFill /></Col>
                <Col style={{ textAlign: 'left' }}><Text weight="bold">司機電話</Text><span style={{ color: 'GrayText' }}>{order.driver.phoneNumber}</span></Col>
              </Row>
              <br></br>
              <Row>
                <Col><CardText /></Col>
                <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">車號</Text><span style={{ color: 'GrayText' }}>{order.driver.licencePlateNumber}</span></Col>
                <Col><CardText /></Col>
                <Col style={{ textAlign: 'left' }}><Text weight="bold">車輛品牌</Text><span style={{ color: 'GrayText' }}>{order.driver.carBrand}</span></Col>
              </Row>
              <br></br>
              <Row>
                <Col><CardText /></Col>
                <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">車輛型號</Text><span style={{ color: 'GrayText' }}>{order.driver.carModel}</span></Col>
                <Col><CardText /></Col>
                <Col style={{ textAlign: 'left' }}><Text weight="bold">車輛顏色</Text><span style={{ color: 'GrayText' }}>{order.driver.carColor}</span></Col>
              </Row>
              <br></br>
              <Row>
                <Col><Calendar2 /></Col>
                <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">租車開始時間</Text><span style={{ color: 'GrayText' }}>{order.rentalStartTime ? new Date(order.rentalStartTime).toLocaleString('zh-TW') : 'N/A'}</span></Col>
                <Col><Calendar2 /></Col>
                <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">租車結束時間</Text><span style={{ color: 'GrayText' }}>{order.rentalEndTime ? new Date(order.rentalEndTime).toLocaleString('zh-TW') : 'N/A'}</span></Col>
                {!order.rentalStartTime && <Col><Pen onClick={() => { onOrderAction(order, OrderActionType.SetRentalTime) }} /></Col>}
              </Row>
              <br></br>
              <Row>
                <Col><CardText /></Col>
                <Col style={{ textAlign: 'left' }}><Text weight="bold">出租單</Text>
                  {(order.signatureFileName !== null && order.signatureFileName.length > 0) ? <Button size="xs" appearance="primary"
                    onClick={() => document.location.href = `/driver/order/${order.orderID}/veiwrentform`}>檢視</Button> : <Button size="xs" appearance="primary" onClick={() => document.location.href = `/driver/order/${order.orderID}/signing`}>乘客簽名</Button>}
                </Col>
              </Row>
              <br></br>
              {/* <Row>
                <Col xs={2}></Col>
                <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">司機聊聊</Text><ChatDotsFill /></Col>
              </Row> */}
            </>}

            {order.fromUserUID && <>
              <Row>
                <Col><ArrowRightSquare /></Col>
                <Col xs={8} style={{ textAlign: 'left' }}><Text weight="bold">轉單來源</Text><span style={{ color: 'GrayText' }}>此訂單由UID({order.fromUserUID}) 轉移而來</span></Col>
              </Row>
            </>}

            <br></br>
            <Row>
              <Col><GeoAltFill /></Col>
              <Col style={{ textAlign: 'left' }}><Text weight="bold">建單時間</Text><span style={{ color: 'GrayText' }}>{getDisplayDateTimeString(order.createdAt)}</span></Col>
            </Row>

            <br></br>


          </>
          }
        </div >
      </div>
    )
  }

  return (order ? orderDisplay() : null);

}
